var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSurvey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M780 990H220c-77.3 0-140-62.7-140-140V220c0-77.3 62.7-140 140-140h70c0-8.8 2-16.9 5-24.6.9-2.3 2-4.3 3.1-6.5 2.7-5.4 6-10.3 9.9-14.8 1.6-1.8 3-3.6 4.7-5.2 5.9-5.5 12.5-10.3 20-13.5C341.1 12 350.3 10 360 10h280c9.7 0 18.9 2 27.2 5.5 7.6 3.2 14.1 8 20 13.5 1.7 1.6 3.1 3.4 4.7 5.2 3.9 4.5 7.2 9.4 9.9 14.8 1.1 2.2 2.2 4.2 3.1 6.5 2.9 7.7 5 15.9 5 24.6h70c77.3 0 140 62.7 140 140v630C920 927.3 857.3 990 780 990zM640 80H360v70h280V80zm210 140c0-38.6-31.3-70-70-70h-70c0 38.7-31.3 70-70 70H360c-38.7 0-70-31.3-70-70h-70c-38.7 0-70 31.3-70 70v630c0 38.7 31.3 70 70 70h560c38.7 0 70-31.3 70-70V220zM290 640h420v70H290v-70zm350-280h70v70h-70v-70zm70 210H290v-70h420v70zM290 360h280v70H290v-70z"
  })));
}

export default SvgSurvey;